module.exports = __webpack_public_path__ + "b535a6849cde55d62ce90b16709db9e9.woff2";